import React from 'react'
import PropTypes from 'prop-types'
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography'
import moment from 'moment-timezone';

function ActivityFeedTime({ colorStyle, activityTime, splitTime }) {
  let formattedDay = moment.utc(activityTime).format('ddd M/DD/YY')
  let formattedTime = moment.utc(activityTime).format('h:mma')
  let formattedDateTime = splitTime ? (
    <Typography variant="body1" className={colorStyle}>
      {formattedDay} <br /> {formattedTime}
    </Typography>
  ) : (
      <Typography variant="body1" className={colorStyle}>
        {formattedDay} {formattedTime}
      </Typography>
    )
  return formattedDateTime
}

ActivityFeedTime.propTypes = {
  colorStyle: PropTypes.string,
  activityTime: PropTypes.string.isRequired,
  splitTime: PropTypes.bool
}

ActivityFeedTime.defaultProps = {
  colorStyle: '',
  splitTime: false
}

export default ActivityFeedTime
